import {Component, OnInit} from '@angular/core';
import {DeploymentsService} from "../deployments.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {DataService} from "../data.service";
import * as moment from 'moment';
import {TimezoneService} from "../timezone.service";

@Component({
  selector: 'app-deployments-monitoring',
  templateUrl: './deployments-monitoring.component.html',
  styleUrls: ['./deployments-monitoring.component.scss']
})
export class DeploymentsMonitoringComponent implements OnInit {

    deploymentNumber: number | null;

    missions: any = null;
    erddapMetadata: any = null;
    variableLookup: { [key: string]: string } = {};
    selectedMission: any = null;
    selectedMetadata: { delayed: { id: string, variables: string[] } | null, realtime: { id: string, variables: string[] } | null };
    missionHasData: any = null;
    selectedDatasetType: 'Delayed' | 'Realtime';

    moment: any = moment;
    timezone: any = null;

    graphVariable: string | null;
    graphPeriod: 'week' | 'day' | 'hour' = 'week';
    graphData: string | null = null;

    constructor(
        private deploymentsService: DeploymentsService,
        private dataService: DataService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private timezoneService: TimezoneService) {
        this.timezone = timezoneService.timezone;
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
    }

    ngOnInit(): void {
        this.deploymentsService.getAllDeployments().then(response => {
            this.missions = response.sort((a, b) => b.deployment_number - a.deployment_number);
            this.deploymentsService.getMetadata().then(response => {
                this.erddapMetadata = response;
                this.loadMission();
            });
        });

        this.dataService.getVariableLookup().then(response => {
            this.variableLookup = response;
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip()
            }, 500);
        });

        this.deploymentNumber = parseInt(this.route.snapshot.params['deploymentNumber']);
        console.debug('deployments number:', this.deploymentNumber);

        if(!this.deploymentNumber) {
          let memDepNum = localStorage.getItem('selectedDeploymentNumber');
          if(memDepNum) {
              this.navigateTo(parseInt(memDepNum));
          }
        }
    }

    navigateTo(deploymentNumber: number) {
        console.debug('current deployments number:', this.deploymentNumber);
        console.debug('new deployments number:', deploymentNumber);
        localStorage.setItem('selectedDeploymentNumber', deploymentNumber.toString());
        if (this.deploymentNumber) {
            this.router.navigateByUrl(this.router.url.replace(this.deploymentNumber.toString(), deploymentNumber.toString()));
        } else {
            this.router.navigateByUrl(this.router.url.replace('all', deploymentNumber.toString()));
        }
    }

    loadMission() {
        this.graphData = null;

        if (!this.deploymentNumber) {
            this.selectedMission = null;
            return;
        }

        this.selectedMission = Array.getByProperty(this.missions, this.deploymentNumber, 'deployment_number');

        if (this.selectedMission) {
            this.selectedMetadata = this.erddapMetadata[this.deploymentNumber];
            this.missionHasData = this.selectedMetadata.delayed || this.selectedMetadata.realtime;
            // if delayed is available, select it, otherwise select realtime
            if (this.selectedMetadata.delayed) {
                this.selectedDatasetType = 'Delayed';
            } else if (this.selectedMetadata.realtime) {
                this.selectedDatasetType = 'Realtime';
            }
        }

    }

    graph() {
        if (this.graphVariable && this.graphPeriod) {
            let dataset: string;
            if (this.selectedDatasetType == 'Delayed' && this.selectedMetadata.delayed) {
                dataset = this.selectedMetadata.delayed.id;
            } else if (this.selectedMetadata.realtime) {
                dataset = this.selectedMetadata.realtime.id;
            } else {
                throw ReferenceError('Selected dataset type is unavailable');
            }
            $('.graph-image').show();
            this.spinner.show('spinner-graph');
            const end_time = this.selectedMission.end_time;
            this.dataService.graph(dataset, this.graphVariable, undefined, 'false', this.graphPeriod, end_time).then(result => {
                this.spinner.hide('spinner-graph');
                this.graphData = result.toString();
            });
        }
    }
}
